import { AppState } from "../app.state";

export const getChannel = (state: AppState) => state.bluetoothSimulation.activeChannel;
